import * as types from './constants';

export const setEstablishmentId = ({ establishmentId = '' }) => ({
  type: types.SET_ESTABLISHMENT_ID,
  id: establishmentId
});

export const setEstablishmentUuid = ({ establishmentUuid = '' }) => ({
  type: types.SET_ESTABLISHMENT_UUID,
  uuid: establishmentUuid
});

export const setPreviousEstablishmentId = establishmentId => ({
  type: types.SET_PREVIOUS_ESTABLISHMENT_ID,
  establishmentId
});

export const setBusinessInfo = data => ({
  type: types.SET_BUSINESS_INFO,
  data
});

export const setEstablishments = data => ({
  type: types.SET_ESTABLISHMENTS,
  data
});

export const setEstablishmentTypes = establishmentTypes => ({
  type: types.SET_ESTABLISHMENT_TYPES,
  establishmentTypes
});

export const clearBusinessInfo = () => ({
  type: types.CLEAR_BUSINESS_INFO
});

export const clearAddress = () => ({
  type: types.CLEAR_ADDRESS
});

export const handlePostalCode = status => ({
  type: types.HANDLE_POSTAL_CODE,
  status
});

export const handleLoading = status => ({
  type: types.HANDLE_LOADING,
  status
});

export const setEditingState = status => ({
  type: types.HANDLE_EDITING,
  status
});

export const setEstablishmentErrors = errors => ({
  type: types.SET_ESTABLISHMENT_ERRORS,
  errors
});

export const clearEstablishmentErrors = () => ({
  type: types.CLEAR_ESTABLISHMENT_ERRORS
});

export const setSuperlogicaList = data => ({
  type: types.SET_SUPERLOGICA_LIST,
  data
});

export const setJumpCarStoreDownload = data => ({
  type: types.SET_JUMP_CAR_STORE_DOWNLOAD,
  data
});

export const setIsJumpCarStoreDownloadLoading = isLoading => ({
  type: types.SET_IS_JUMP_CAR_STORE_DOWNLOAD_LOADING,
  isLoading
});

export const setIsJumpCarStoreDownloadAvailable = isAvailable => ({
  type: types.SET_IS_JUMP_CAR_STORE_DOWNLOAD_AVAILABLE,
  isAvailable
});